import { render } from "./BrandingCard.vue?vue&type=template&id=918c5e22"
import script from "./BrandingCard.vue?vue&type=script&lang=js"
export * from "./BrandingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__